var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gmap-autocomplete',{staticClass:"address-input mb-0",class:_vm.dense ? 'dense': '',attrs:{"placeholder":_vm.placeholder,"value":_vm.value},on:{"focus":_vm.deleteError,"place_changed":_vm.onPlaceChanged,"input":_vm.onChanging}})
}
var staticRenderFns = []

export { render, staticRenderFns }